import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { U as a } from "./unified-link.DNdCokeG.js";
const x = ({
  className: c,
  phoneNumber: l,
  title: i,
  titleClassName: d,
  icon: n
  //   isLoading,
}) => {
  const t = {
    value: {
      href: `tel:${l == null ? void 0 : l.replace(/ /g, "")}`,
      text: l
    }
  };
  return l ? /* @__PURE__ */ s("div", { className: c, children: [
    i ? /* @__PURE__ */ r("p", { className: d, children: i }) : null,
    /* @__PURE__ */ s("span", { children: [
      n,
      /* @__PURE__ */ r(a, { field: t, children: l })
    ] })
  ] }) : null;
};
export {
  x as P
};
